export type AgentOs = 'windows' | 'mac' | 'linux';

export interface AgentBuild {
  os: AgentOs;
  label: string;
  file: string;
  // Ce que l'opérateur doit faire une fois le fichier reçu.
  hint: string;
}

// L'agent d'impression est publié en trois binaires sur la release du SDK (m-scan-device-kit).
// Le tag est épinglé : « latest » changerait de sens le jour où une autre release serait publiée.
const RELEASE_TAG = 'agent-desktop-v1';
const RELEASE_URL = `https://github.com/malo-dev/-m-scan-device-kit/releases/download/${RELEASE_TAG}`;

export const AGENT_BUILDS: AgentBuild[] = [
  {
    os: 'windows',
    label: 'Windows',
    file: 'm-scan-device-agent-win-x64.exe',
    hint: 'Double-cliquez sur le fichier. Si Windows affiche un avertissement, choisissez « Informations complémentaires » puis « Exécuter quand même ».',
  },
  {
    os: 'mac',
    label: 'macOS',
    file: 'm-scan-device-agent-macos-x64',
    hint: 'Dans le Terminal : chmod +x puis lancez le fichier. Sur un Mac Apple Silicon, il tourne via Rosetta.',
  },
  {
    os: 'linux',
    label: 'Linux',
    file: 'm-scan-device-agent-linux-x64',
    hint: 'Dans un terminal : chmod +x puis lancez le fichier.',
  },
];

export const downloadUrl = (build: AgentBuild) =>
  `${RELEASE_URL}/${build.file}`;

interface NavigatorLike {
  userAgent?: string;
  platform?: string;
  userAgentData?: { platform?: string };
}

// Le système du poste, lu dans le navigateur. Une tablette ou un téléphone ne peut pas faire tourner l'agent : null.
export const detectOs = (nav: NavigatorLike): AgentOs | null => {
  const agent = nav.userAgent ?? '';
  // Android annonce aussi « Linux », et un iPad se présente parfois comme un Mac : le mobile se teste d'abord.
  if (/android|iphone|ipad|ipod|mobile/i.test(agent)) return null;
  const platform = (
    nav.userAgentData?.platform ??
    nav.platform ??
    ''
  ).toLowerCase();
  const haystack = `${platform} ${agent.toLowerCase()}`;
  if (haystack.includes('win')) return 'windows';
  if (haystack.includes('mac')) return 'mac';
  if (
    haystack.includes('linux') ||
    haystack.includes('x11') ||
    haystack.includes('cros')
  )
    return 'linux';
  return null;
};

export const buildFor = (os: AgentOs | null) =>
  AGENT_BUILDS.find((build) => build.os === os) ?? null;
